var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',{attrs:{"name":_vm.name,"value":_vm.value,"options":_vm.options,"effect":_vm.effect,"color":_vm.color,"round":_vm.round,"size":_vm.size,"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }